// import { InputAdornment } from "@mui/material";
import moment from "moment";
import {
  TextFieldType,
  AutocompleteType,
  DatePickerType,
  RadioType,
  // CheckboxType,
  Radios,
  // CustomFormField,
} from "../../../utilis/component/CustomFormElement";
import dayjs from "dayjs";
import {
  AddressType,
  CountryType,
  LanguageType,
  MaritalStatusType,
  RaceType,
  ReligionType,
  StateType,
  GroupingFamilyType,
} from "./type/RegistrationDataType";

const today = moment(new Date()).format("yyyy-MM-DD");

type PersonalDetailsFieldType = {
  firstName: TextFieldType;
  middleName: TextFieldType;
  lastName: TextFieldType;
  dob: DatePickerType;
  age: TextFieldType;
  gender: RadioType;
  maritalStatus: AutocompleteType;
  language: AutocompleteType;
  race: AutocompleteType;
  isVip: RadioType;
  id: TextFieldType;
  groupingFamily: AutocompleteType;
};

type AdderssDetailsFieldType = {
  adress: TextFieldType;
  addressType: AutocompleteType;
  country: AutocompleteType;
  nationality: AutocompleteType;
  state: AutocompleteType;
  cityOrPlace: TextFieldType;
  postOffice: AutocompleteType;
  mobile: TextFieldType;
  email: TextFieldType;
  religion: AutocompleteType;
  code: AutocompleteType;
};

export type EmergencyContactType = {
  contactType: AutocompleteType;
  givenName: TextFieldType;
  familyName: TextFieldType;
  mobileNumber: TextFieldType;
  addressType: AutocompleteType;
  relationWithPatient: AutocompleteType;
  streetAddress: TextFieldType;
  address: TextFieldType;
};

 const genderFields: Radios[] = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
  
];

const idTypes = [
  {
    label: "Yes",
    value: 1,
  },
  {
    label: "No",
    value: 0,
  },
];

const groupingFamilyOptions: GroupingFamilyType[] = [
  { id: 1, name: "Royal Family" },
  { id: 2, name: "company" },
];

const personalDetailsFields: PersonalDetailsFieldType = {
  firstName: {
    element: "input",
    name: "firstName",
    fieldProps: { label: "First name" },
    rules: { required: "First name required" },
  },
  middleName: {
    element: "input",
    name: "middleName",
    fieldProps: { label: "Middle name" },
    rules: { required: false },
  },
  lastName: {
    element: "input",
    name: "lastName",
    fieldProps: { label: "Last name" },
    rules: { required: "Last name required" },
  },
  dob: {
    element: "datepicker",
    name: "dob",
    dateFormat: "DD-MM-YYYY",
    fieldProps: { label: "DOB", type: "date", inputProps: { max: today } },
    rules: { required: "DOB required" },
    calenderProps: { maxDate: dayjs() },
  },
  age: {
    element: "input",
    name: "age",
    fieldProps: { type: "number", label: "Age" },
    rules: { required: "Age required" },
  },

  gender: {
    element: "radio",
    name: "gender",
    fieldProps: { label: "Gender" },
    radioProps: { label: "Gender", row: true },
    radios: genderFields,
    rules: { required: " " },
  },

  maritalStatus: {
    element: "autocomplete",
    name: "maritalStatus",
    fieldProps: { label: "Marital status" },
    rules: { required: false },
    autocompleteProps: {
      getOptionLabel: (option: MaritalStatusType) => option.maritalStatus,
      isOptionEqualToValue: (
        option: MaritalStatusType,
        value: MaritalStatusType
      ) => option.id == value.id,
    },
  },

  language: {
    element: "autocomplete",
    name: "language",
    fieldProps: { label: "Language" },
    rules: { required: false },
    autocompleteProps: {
      getOptionLabel: (option: LanguageType) => option.langName,
      isOptionEqualToValue: (option: LanguageType, value: LanguageType) =>
        option.langId == value.langId,
    },
  },

  race: {
    element: "autocomplete",
    name: "race",
    fieldProps: { label: "Race" },
    rules: { required: false },
    autocompleteProps: {
      getOptionLabel: (option: RaceType) => option.raceName,
      isOptionEqualToValue: (option: RaceType, value: RaceType) =>
        option.raceId == value.raceId,
    },
  },

  isVip: {
    element: "radio",
    name: "isVip",
    fieldProps: { label: "VIP Patient" },
    radioProps: { label: "VIP Patient", row: true },
    radios: idTypes,
    rules: { required: " " },
  },

  id: {
    element: "input",
    name: "id",
    fieldProps: {},
    rules: {
      required: `Qatar Id required`,
    },
  },

  groupingFamily: {
    element: "autocomplete",
    name: "groupingFamily",
    fieldProps: { label: "Grouping" },
    rules: { required: false },
    autocompleteProps: {
      getOptionLabel: (option: GroupingFamilyType) => option.name,
      isOptionEqualToValue: (
        option: GroupingFamilyType,
        value: GroupingFamilyType,
      ) => option.id === value.id,
    },
  },
};

const addressDetailsFields: AdderssDetailsFieldType = {
  adress: {
    element: "input",
    name: "address",
    fieldProps: { label: "Address" },
    rules: { required: false },
  },

  addressType: {
    element: "autocomplete",
    name: "addressType",
    fieldProps: { label: "Address type" },
    rules: { required: false },
    autocompleteProps: {
      getOptionLabel: (option: AddressType) => option.addressType,
      isOptionEqualToValue: (option: AddressType, value: AddressType) =>
        option.id == value.id,
    },
  },

  country: {
    element: "autocomplete",
    name: "country",
    fieldProps: { label: "Country" },
    rules: { required: "Country required" },
    autocompleteProps: {
      getOptionLabel: (option: CountryType) => option.countryName,
      isOptionEqualToValue: (option: CountryType, value: CountryType) =>
        option.id == value.id,
      // disableClearable:true
    },
  },

  nationality: {
    element: "autocomplete",
    name: "nationality",
    fieldProps: { label: "Nationality" },
    rules: { required: "Nationality required" },
    autocompleteProps: {
      getOptionLabel: (option: CountryType) =>
        `${option.isoCode ? "(" + option.isoCode + ")" : ""}${option.nationality}`,
      isOptionEqualToValue: (option: CountryType, value: CountryType) =>
        option.id == value.id,
    },
  },

  code: {
    element: "autocomplete",
    name: "countryCode",
    fieldProps: {
      label: "Code",
      // InputProps:{startAdornment:<AddIcon sx={{ fontSize: "20px" }}/>}
    },
    rules: { required: "Code required" },
    autocompleteProps: {
      getOptionLabel: (option: CountryType) => option.countryCode,
      isOptionEqualToValue: (option: CountryType, value: CountryType) =>
        option.id == value.id,
      disableClearable: true,
      renderOption: (props, option: CountryType) => (
        <span {...props}>
          {`${option?.isoCode || ""} ${option.countryCode}`}
        </span>
      ),
    },
  },

  state: {
    element: "autocomplete",
    name: "state",
    fieldProps: { label: "State" },
    rules: { required: "State required" },
    autocompleteProps: {
      getOptionLabel: (option: StateType) => option.stateName,
      isOptionEqualToValue: (option: StateType, value: StateType) =>
        option.stateId == value.stateId,
    },
  },

  cityOrPlace: {
    element: "input",
    name: "place",
    fieldProps: { label: "City" },
    rules: { required: "City required" },
  },

  postOffice: {
    element: "autocomplete",
    name: "postOffice",
    fieldProps: { label: "Post Office" },
    rules: { required: "Post office required" },
    autocompleteProps: {
      getOptionLabel: (option) => option.po_name,
      isOptionEqualToValue: (option, value) => option.po_id == value.po_id,
    },
  },

  mobile: {
    element: "input",
    name: "mobileNo",
    fieldProps: { label: "Mobile",type:"number" },
    rules: {
      required: "Mobile required",
      maxLength: { value: 13, message: "Maximum length 13" },
    },
  },

  email: {
    element: "input",
    name: "email",
    fieldProps: { label: "Email", type: "email" },
    rules: { required: false },
  },

  religion: {
    element: "autocomplete",
    name: "religion",
    fieldProps: { label: "Religion" },
    rules: { required: false },
    autocompleteProps: {
      getOptionLabel: (option:ReligionType) => option.religionName,
      isOptionEqualToValue: (option:ReligionType, value:ReligionType) =>
        option.religionId == value.religionId,
    },
  },
};

// const emergencyContact: EmergencyContactType[] = [
//   {
//     contactType: {
//       element: "autocomplete",
//       name: "contactType1",
//       fieldProps: { label: "Contact type" },
//       rules: { required: false },
//       autocompleteProps: {
//         getOptionLabel: (option: any) => option.contactroll_name,
//         isOptionEqualToValue: (option, value) =>
//           option.contactroll_id == value.contactroll_id,
//       },
//     },
//     givenName: {
//       element: "input",
//       name: "givenName1",
//       fieldProps: { label: "Given name " },
//       rules: { required: false },
//     },
//     familyName: {
//       element: "input",
//       name: "familyName1",
//       fieldProps: { label: "Family name " },
//       rules: { required: false },
//     },
//     mobileNumber: {
//       element: "input",
//       name: "mobileNumber1",
//       fieldProps: { label: "Mobile number " },
//       rules: { required: false },
//     },
//     addressType: {
//       element: "autocomplete",
//       name: "addressTypeId1",
//       fieldProps: { label: "Address type " },
//       rules: { required: false },
//       autocompleteProps: {
//         getOptionLabel: (option: any) => option.addresstype,
//         isOptionEqualToValue: (option, value) => option.Id == value.Id,
//       },
//     },
//     relationWithPatient: {
//       element: "autocomplete",
//       name: "relationshipId1",
//       fieldProps: { label: "Relation with patient " },
//       rules: { required: false },
//       autocompleteProps: {
//         getOptionLabel: (option: any) => option.relation_name,
//         isOptionEqualToValue: (option, value) =>
//           option.relation_id == value.relation_id,
//       },
//     },
//     streetAddress: {
//       element: "input",
//       name: "streetAddress1",
//       fieldProps: { label: "Street address" },
//       rules: { required: false },
//     },
//     address: {
//       element: "input",
//       name: "emAddress1",
//       fieldProps: { label: "Address " },
//       rules: { required: false },
//     },
//   },
//   {
//     contactType: {
//       element: "autocomplete",
//       name: "contactType2",
//       fieldProps: { label: "Contact type " },
//       rules: { required: false },
//       autocompleteProps: {
//         getOptionLabel: (option: any) => option.contactroll_name,
//         isOptionEqualToValue: (option, value) =>
//           option.contactroll_id == value.contactroll_id,
//       },
//     },
//     givenName: {
//       element: "input",
//       name: "givenName2",
//       fieldProps: { label: "Given name " },
//       rules: { required: false },
//     },
//     familyName: {
//       element: "input",
//       name: "familyName2",
//       fieldProps: { label: "Family name " },
//       rules: { required: false },
//     },
//     mobileNumber: {
//       element: "input",
//       name: "mobileNumber2",
//       fieldProps: { label: "Mobile number " },
//       rules: { required: false },
//     },
//     addressType: {
//       element: "autocomplete",
//       name: "addressTypeId2",
//       fieldProps: { label: "Address type " },
//       rules: { required: false },
//       autocompleteProps: {
//         getOptionLabel: (option: any) => option.addresstype,
//         isOptionEqualToValue: (option, value) => option.Id == value.Id,
//       },
//     },
//     relationWithPatient: {
//       element: "autocomplete",
//       name: "relationshipId2",
//       fieldProps: { label: "Relation with patient" },
//       rules: { required: false },
//       autocompleteProps: {
//         getOptionLabel: (option: any) => option.relation_name,
//         isOptionEqualToValue: (option, value) =>
//           option.relation_id == value.relation_id,
//       },
//     },
//     streetAddress: {
//       element: "input",
//       name: "streetAddress2",
//       fieldProps: { label: "Street address " },
//       rules: { required: false },
//     },
//     address: {
//       element: "input",
//       name: "emAddress2",
//       fieldProps: { label: "Address " },
//       rules: { required: false },
//     },
//   },
// ];

export { personalDetailsFields, addressDetailsFields, groupingFamilyOptions };
